import Vue from 'vue'
import router from '../../router/';
import {
  AUTH_LOGIN,
  AUTH_LOGOUT, CHANGE_USER_WORK_STATUS,
  CREATE_USER, DELETE_USER,
  EDIT_BALANCE, EDIT_SUPPORT_LIMIT,
  EDIT_USER,
  LOAD_USERS_LIST, RESET_SUPPORT_LIMIT,
} from '../const/user';
import { HTTP_DELETE, HTTP_GET, HTTP_POST, HTTP_PUT } from '../const';
import { RESET_ORDERS } from "../const/orders";
import { RESET_SETTINGS } from "../const/settings";

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || '',
    username: localStorage.getItem('username') || '',
    role: localStorage.getItem('role') || '',
    users: [],
  },
  getters: {
    getRole: state => state.role,
    getToken: state => state.token,
    isAdmin: state => state.role === 'admin' || state.role === 'superadmin',
    isSupport: state => state.role === 'support',
    users: state => state.users,
    username: state => state.username,
  },
  actions: {
    [AUTH_LOGIN]: async ({ dispatch, commit }, { name, password, data }) => {
      const request = await dispatch(HTTP_POST, {
        method: AUTH_LOGIN,
        body: { name, password, data },
        with_token: false,
        no_commit: true,
        namespace: 'user',
      }, { root: true });

      if (request?.success) {
        const data = request.data;
        const token = data.token;
        const user = data.user;
        localStorage.setItem('token', token);
        localStorage.setItem('username', user.name);
        localStorage.setItem('role', user.role);

        commit(AUTH_LOGIN, {
          token,
          id: user.id,
          username: user.name,
          role: user.role,
        });
        await router.push({ name: 'OrdersList' });
      }
      return request;
    },
    [AUTH_LOGOUT]: async ({ commit }) => {
      commit(`orders/${RESET_ORDERS}`, null, { root: true });
      commit(`settings/${RESET_SETTINGS}`, null, { root: true });
      commit(AUTH_LOGOUT);
      await router.push({ name: 'Login' });
    },
    [LOAD_USERS_LIST]: async ({ dispatch }) => {
      await dispatch(HTTP_GET, {
        method: LOAD_USERS_LIST,
        namespace: 'user',
      }, { root: true });
    },
    [CREATE_USER]: async ({ dispatch }, user) => {
      const request = await dispatch(HTTP_POST, {
        method: CREATE_USER,
        namespace: 'user',
        body: user,
        no_commit: true,
      }, { root: true });
      return request;
    },
    [EDIT_USER]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_USER,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [EDIT_BALANCE]: async ({ dispatch }, { id, data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_BALANCE,
        namespace: 'user',
        body: data,
        replace: { id },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [CHANGE_USER_WORK_STATUS]: async ({ dispatch }, { data, status }) => {
      const request = await dispatch(HTTP_PUT, {
        method: CHANGE_USER_WORK_STATUS,
        namespace: 'user',
        replace: { status },
        body: data,
        no_commit: true,
      }, { root: true });
      return request;
    },
    [EDIT_SUPPORT_LIMIT]: async ({ dispatch }, { data }) => {
      const request = await dispatch(HTTP_PUT, {
        method: EDIT_SUPPORT_LIMIT,
        namespace: 'user',
        body: data,
        no_commit: true,
      }, { root: true });
      return request;
    },
    [RESET_SUPPORT_LIMIT]: async ({ dispatch }, { name }) => {
      const request = await dispatch(HTTP_PUT, {
        method: RESET_SUPPORT_LIMIT,
        namespace: 'user',
        body: { name },
        no_commit: true,
      }, { root: true });
      return request;
    },
    [DELETE_USER]: async ({ dispatch }, { name }) => {
      const request = await dispatch(HTTP_DELETE, {
        method: DELETE_USER,
        namespace: 'user',
        body: { name },
        no_commit: true,
      }, { root: true });
      return request;
    },
  },
  mutations: {
    [AUTH_LOGIN]: (state, { token, username, role }) => {
      Vue.set(state, 'token', token);
      Vue.set(state, 'username', username);
      Vue.set(state, 'role', role);
    },
    [AUTH_LOGOUT]: (state) => {
      localStorage.clear();
      Vue.set(state, 'token', '');
      Vue.set(state, 'username', '');
      Vue.set(state, 'role', '');
      Vue.set(state, 'users', []);
    },
    [LOAD_USERS_LIST]: (state, { data }) => {
      if (data) {
        Vue.set(state, 'users', data);
      }
    },
  },
};
